export default __webpack_public_path__ + "static/media/image-banner-space.647b00f6.jpg";